import * as React from "react";
import {
  AppBar,
  Box,
  Drawer,
  IconButton,
  Toolbar,
  useMediaQuery,
  useTheme,
  ListItem,
  ListItemIcon,
  ListItemText,
  Radio,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, Link } from "react-router-dom";
import PropTypes from "prop-types";
import navItems, { getNavItems } from "./NavItems";
import useUnreadBadge from "./useUnreadBadge";

import { logout } from "../../actions/action_auth";
import DrawerContent from "./DrawerContent";
import CloseIcon from "@mui/icons-material/Close";
import NewLogo from "./Image/new-qrata.svg";
import "./new-navbar.css";
// icons...
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
// import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import { SupervisorAccountOutlined } from "@mui/icons-material";
import PasswordOutlinedIcon from "@mui/icons-material/PasswordOutlined";
import HowToRegOutlinedIcon from "@mui/icons-material/HowToRegOutlined";
import TimelineIcon from "@mui/icons-material/Timeline";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import ContactMailOutlinedIcon from "@mui/icons-material/ContactMailOutlined";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import AnalyticsOutlinedIcon from "@mui/icons-material/AnalyticsOutlined";
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import SubMenu, { withPopover } from "./SubMenu";
import { List } from "semantic-ui-react";
import { currenciesWithSymbol } from "../../OptionData";
import { getLandingRoute } from "../../utils/landingRoute";
function DrawerAppBar({ window }) {
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [analyticsAnchorEl, setAnalyticsAnchorEl] = React.useState(null);
  const [selected, setSelected] = React.useState("");
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const { role, first_name, last_name, email, auth, clientId } = useSelector(
    (state) => state.user.user
  );
  const currentCurrency = useSelector((state) => state.user.currency);
  const [currencyAnchorEl, setCurrencyAnchorEl] = React.useState(null);

  // Live unread badge for the Messages nav item (shared hook)
  const messagesBadge = useUnreadBadge();

  const filteredNavItems = React.useMemo(() => {
    const dynamicNavItems = getNavItems(role, clientId, messagesBadge);
    return dynamicNavItems.filter((item) => !item.roles || item.roles.includes(role));
  }, [role, clientId, messagesBadge]);

  const handleLogout = () => {
    dispatch(logout()).then(() => {
      navigate("/signin");
      localStorage.removeItem("prevURL");
    });
  };

  const handleCurrencyChange = (currencyCode) => {
    dispatch({ type: "SET_CURRENCY", payload: currencyCode });
  };

 const accountItems = [
  {
    label: role === "client" ? "Company's Account" : "Account View",
    icon: <ManageAccountsOutlinedIcon />,
    path: "/account-view",
    show: role === "Admin" || role === "Account Manager" || role === "client",
  },
  {
    label: "Impersonate Users",
    icon: <SupervisorAccountOutlined />,
    path: "/impersonate-users",
    show: role === "Admin",
  },
  {
    label: "Dashboard",
    icon: <AnalyticsOutlinedIcon />,
    path: "/dashboard",
    show: role === "client",
  },
  {
    label: "Users",
    icon: <GroupOutlinedIcon />,
    path: "/team-members",
    show: role === "Admin",
  },
  {
    label: role === "Admin" ? "Change Password" : "Profile Settings",
    icon: role === "Admin" ? <PasswordOutlinedIcon /> : <ContactMailOutlinedIcon />,
    path: role === "Admin" ? "/changepassword" : "/client/editprofile",
    show: true,
  },
  {
    label: "Pods",
    icon: <ManageAccountsOutlinedIcon />,
    path: "/add-pod",
    show: role === "Admin" || role === "Account Manager",
  },
  {
    label: "Logout",
    icon: <ArrowBackOutlinedIcon />,
    onClick: handleLogout,
    show: true,
  },
].filter((item) => item.show);

  // const analyticsItems = [
  //   {
  //     label: "Ops Dashboard",
  //     icon: <ManageAccountsOutlinedIcon />,
  //     path: "/daily-report",
  //   },
  //   {
  //     label: "Admin Dashboard",
  //     icon: <PasswordOutlinedIcon />,
  //     path: "/admin-dashboard",
  //   },
  //   // {
  //   //   label: "Hiring Report",
  //   //   icon: <HowToRegOutlinedIcon />,
  //   //   path: "/hiring-report",
  //   // },
  //   {
  //     label: "Candidate Report",
  //     icon: <TimelineIcon />,
  //     path: "/candidate-report",
  //   },
  // ];

  const analyticsItems = React.useMemo(() => {
  if (role === "Admin") {
    return [
      { label: "Ops Dashboard", icon: <ManageAccountsOutlinedIcon />, path: "/daily-report" },
      { label: "Admin Dashboard", icon: <PasswordOutlinedIcon />, path: "/admin-dashboard" },
      { label: "Candidate Report", icon: <TimelineIcon />, path: "/candidate-report" },
      { label: "Recruiter Dashboard", icon: <ManageAccountsIcon />, path: "/rec-dashboard" },
      { label: "Offer/Joiner", icon: <ManageAccountsOutlinedIcon />, path: "/offer-joiner" },
    ];
  }
  if (role === "Account Manager") {
    // Scoped to their assigned accounts — enforce this server-side too,
    // not just by hiding menu items.
    return [
      { label: "Ops Dashboard", icon: <ManageAccountsOutlinedIcon />, path: "/daily-report" },
      { label: "Candidate Report", icon: <TimelineIcon />, path: "/candidate-report" },
      { label: "Recruiter Dashboard", icon: <ManageAccountsIcon />, path: "/rec-dashboard" },
      { label: "Offer/Joiner", icon: <ManageAccountsOutlinedIcon />, path: "/offer-joiner" },
    ];
  }
  if (role === "Recruiter") {
    return [
      { label: "Recruiter Dashboard", icon: <ManageAccountsIcon />, path: "/rec-dashboard" },
    ];
  }
  return []; // client: no analytics access
}, [role]);

  React.useEffect(() => {
    const currentPath = location.pathname;
    const currentItem = filteredNavItems.find(
      (item) => item.path === currentPath
    );
    if (currentItem) {
      setSelected(currentItem.label);
    } else {
      setSelected("");
    }
    setAnchorEl(null);
    setAnalyticsAnchorEl(null);
  }, [location, filteredNavItems]);

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: "flex" }}>
      <AppBar
        component="nav"
        elevation={0}
        sx={{
          display: { sm: "none" },
          backgroundColor: theme.palette.custom.whiteBackground,
          zIndex: (theme) => theme.zIndex.drawer + 1,
          boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
          height: 56,
          justifyContent: "center",
        }}
      >
        <Toolbar
          sx={{
            px: 2,
            minHeight: "56px !important",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Link to={getLandingRoute(role)}>
            <img src={NewLogo} alt="Qrata" style={{ height: 36 }} />
          </Link>
          {auth && (
            <IconButton edge="end" onClick={() => setMobileOpen(!mobileOpen)}>
              {mobileOpen ? <CloseIcon /> : <MenuIcon />}
            </IconButton>
          )}
        </Toolbar>
      </AppBar>

      {/* Mobile Drawer */}
      <Drawer
        container={container}
        variant="temporary"
        open={mobileOpen}
        onClose={() => setMobileOpen(false)}
        anchor="right"
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: "block", sm: "none" },
          "& .MuiDrawer-paper": { width: 200, position: "fixed" },
        }}
      >
        <DrawerContent
          role={role}
          selected={selected}
          setSelected={setSelected}
          setAnchorEl={setAnchorEl}
          setAnalyticsAnchorEl={setAnalyticsAnchorEl}
          setMobileOpen={setMobileOpen}
          navItems={filteredNavItems}
        />
      </Drawer>

      {/* Desktop Drawer */}
      <Drawer
        className="custom-drawer"
        variant="permanent"
        sx={{
          display: { xs: "none", sm: "block" },
          "& .MuiDrawer-paper": { width: 80, position: "fixed" },
        }}
        open
      >
        <DrawerContent
          role={role}
          selected={selected}
          setSelected={setSelected}
          setAnchorEl={setAnchorEl}
          setAnalyticsAnchorEl={setAnalyticsAnchorEl}
          setCurrencyAnchorEl={setCurrencyAnchorEl}
          navItems={filteredNavItems}
        />
      </Drawer>

      {/* <AccountPopover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        firstName={first_name}
        lastName={last_name}
        email={email}
        role={role}
        handleLogout={handleLogout}
        setSelected={setSelected}
      />
      

      <AnalyticsPopover
        open={Boolean(analyticsAnchorEl)}
        anchorEl={analyticsAnchorEl}
        onClose={() => setAnalyticsAnchorEl(null)}
      /> */}

      <SubMenu
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setTimeout(() => setAnchorEl(null), 100)}
        userInfo={{ firstName: first_name, lastName: last_name, email }}
        items={accountItems}
        navigate={navigate}
        setMobileOpen={setMobileOpen}
      />

      <SubMenu
        open={Boolean(analyticsAnchorEl)}
        anchorEl={analyticsAnchorEl}
        // onClose={() => setAnalyticsAnchorEl(null)}
        onClose={() => setTimeout(() => setAnalyticsAnchorEl(null), 100)}
        items={analyticsItems}
        navigate={navigate}
      />

      <MenuCurrency
        open={Boolean(currencyAnchorEl)}
        anchorEl={currencyAnchorEl}
        onClose={() => setCurrencyAnchorEl(null)}
        selectedCurrency={currentCurrency}
        onCurrencyChange={handleCurrencyChange}
      />
    </Box>
  );
}

DrawerAppBar.propTypes = {
  window: PropTypes.func,
};

export default DrawerAppBar;

function SubMenuForCurrency({
  userInfo,
  onClose,
  selectedCurrency,
  onCurrencyChange,
}) {
  const handleCurrencyChange = (currencyCode) => {
    if (onCurrencyChange) {
      onCurrencyChange(currencyCode);
    }
    if (onClose) {
      onClose();
    }
  };

  return (
    <List>
      {currenciesWithSymbol.map((currency) => (
        <ListItem
          key={currency.code}
          sx={{ cursor: "pointer" }}
          onClick={() => handleCurrencyChange(currency.code)}
        >
          <Radio
            checked={selectedCurrency === currency.code}
            value={currency.code}
            name="currency-radio-group"
          />
          <ListItemText primary={`${currency.name} (${currency.symbol})`} />
        </ListItem>
      ))}
    </List>
  );
}

const MenuCurrency = withPopover(SubMenuForCurrency);

// PropTypes for SubMenuForCurrency
SubMenuForCurrency.propTypes = {
  userInfo: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
  }),
  items: PropTypes.array,
  navigate: PropTypes.func,
  setMobileOpen: PropTypes.func,
  onClose: PropTypes.func,
  selectedCurrency: PropTypes.string,
  onCurrencyChange: PropTypes.func,
};

// Default props for SubMenuForCurrency
SubMenuForCurrency.defaultProps = {
  items: [],
  userInfo: null,
  navigate: null,
  setMobileOpen: null,
  onClose: null,
  selectedCurrency: "USD",
  onCurrencyChange: null,
};
